export const breakpoints = {
  MOBILE: "480px",
  TABLET: "768px",
  DESKTOP: "992px",
};
